var map = {
	"./btn-add.svg": "716c",
	"./btn-del.svg": "7f66",
	"./btn-edit.svg": "05e1",
	"./btn-see.svg": "0522",
	"./btn-set.svg": "1517",
	"./btn-tree.svg": "a837",
	"./center-card.svg": "6517",
	"./data-source.svg": "cdae",
	"./icon-add.svg": "80de",
	"./icon-del.svg": "2fa3",
	"./menu-icon.svg": "80b5",
	"./menu-icon2.svg": "e1e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";